<div class="ups-dialog">
    <div class="dialog-header">
        <h2 mat-dialog-title>{{'complaints.title'|translate}}</h2>
        <mat-dialog-actions>
        </mat-dialog-actions>
        <button type="button" mat-raised-button class="icon-button close-button" mat-dialog-close>
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div class="main-div">
        <div *ngIf= "!isGBUser()" class="inline-elements">
            <p [innerHtml]="'complaints.0' | translate"></p>
            <a [href]="'mailto:' + complaintText">{{complaintText}}</a>
            <p [innerHtml]="'complaints.1' | translate"></p>
            <p [innerHtml]="'complaints.2' | translate"></p>
        </div>

        <div *ngIf= "isGBUser()" class="inline-elements">
            <p [innerHtml]="'complaints.0' | translate"></p>
            <p [innerHtml]="'complaints.1' | translate"></p>
            <a [href]="'mailto:' + complaintText">{{complaintText}}</a>
            <p [innerHtml]="'complaints.2' | translate"></p>
        </div>

        
        <p *ngIf="isGBUser() || isITUser() || !isFRUser()" [innerHtml]="'complaints.3' | translate"></p>
        <p *ngIf="isENGB() || isIT()" [innerHtml]="'complaints.4' | translate"></p>

        <ul *ngIf="isENGB()">
            <li [innerHtml]="'complaints.5' | translate"></li>
            <li [innerHtml]="'complaints.6' | translate"></li>
            <li [innerHtml]="'complaints.7' | translate"></li>
        </ul>

        <ul *ngIf="isIT()">
            <li [innerHtml]="'complaints.5' | translate"></li>
            <li [innerHtml]="'complaints.6' | translate"></li>
            <li [innerHtml]="'complaints.7' | translate"></li>
            <li [innerHtml]="'complaints.8' | translate"></li>
            <li [innerHtml]="'complaints.9' | translate"></li>
        </ul>

        <ul *ngIf="isFR()">
            <li [innerHtml]="'complaints.3' | translate"></li>
            <li [innerHtml]="'complaints.4' | translate"></li>
            <li [innerHtml]="'complaints.5' | translate"></li>
            <li [innerHtml]="'complaints.6' | translate"></li>
            <li [innerHtml]="'complaints.7' | translate"></li>
        </ul>

        <div *ngIf="!(isITUser() || isGBUser() || isFRUser())" [innerHtml]="'complaints.3' | translate"> </div>
        <div *ngIf="!(isIT() || isENGB() || isFR())" [innerHtml]="'complaints.4' | translate"> </div>
        <div *ngIf="!(isIT() || isENGB() || isFR())" [innerHtml]="'complaints.5' | translate"> </div>
        <div *ngIf="!(isIT() || isENGB() || isFR()) " [innerHtml]="'complaints.6' | translate"> </div>
        <p *ngIf="!(isIT() || isENGB() || isFR())" [innerHtml]="'complaints.7' | translate"> </p>
        <p *ngIf ="!isIT()" [innerHtml]="'complaints.8' | translate"> </p>

        <div *ngIf="!isGBUser()" [innerHtml]="'complaints.9' | translate"> </div>
        <div *ngIf="!isGBUser()" [innerHtml]="'complaints.10' | translate"> </div>
        <div *ngIf="!isGBUser()" [innerHtml]="'complaints.11' | translate"> </div>
        <div *ngIf="!isGBUser()" [innerHtml]="'complaints.12' | translate"> </div>

        <p *ngIf="isGBUser()" [innerHtml]="'complaints.9' | translate"></p>
        <p *ngIf="isGBUser()" [innerHtml]="'complaints.10' | translate"></p>
        <div *ngIf="isGBUser()" [innerHtml]="'complaints.11' | translate"></div>
        <p *ngIf="isGBUser()" [innerHtml]="'complaints.12' | translate"></p>

        <div *ngIf="isGBUser()" [innerHtml]="'complaints.13' | translate"></div>
        <p *ngIf="isGBUser()" [innerHtml]="'complaints.14' | translate"> </p>
        <p *ngIf="isGBUser()" [innerHtml]="'complaints.15' | translate"> </p>
        <p *ngIf="isGBUser()" [innerHtml]="'complaints.16' | translate"> </p>
        <strong>
            <p *ngIf="isGBUser()" [innerHtml]="'complaints.17' | translate"> </p>
        </strong>
        <div *ngIf="isGBUser() && !isIT()" [innerHtml]="'complaints.18' | translate" >

        </div>
    </div>
</div>